<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-groups-presenters
    [groupMembers]="groupMembers"
    [groupMembersORIG]="groupMembersORIG"
    [groupTypes]="groupTypes"
    [groupElementTypes]="groupElementTypes"
    [groupElements]="groupElements"
    [groupElementsORIG]="groupElementsORIG"
    [group]="groups"
    [process]="process$ | async"
    [adminCount]="adminCount"
    [selectedError]="selectedError$ | async"
    (memberRowSelectUpdate)="onMemberRowSelectUpdate($event)"
    (elementRowSelectUpdate)="onElementRowSelectUpdate($event)"
    (resetData)="onResetData()"
    (ShowError)="OnShowError($event)"
    (LoadMembers)="onLoadMembers($event)"
>
</ef-groups-presenters>
